import React, { Component } from 'react';
import ScrollToButton from '../../components/buttons/ScrollToButton';
import EnrollingComponent from '../../components/enrolling-component/enrolling-component';
import HomePageSvg from '../../components/homepage-animation/home-page-animation-svg/home-page-svg';
class Banner extends Component {
	constructor(props) {
		super(props);
		this.state = {
			callSvgInterval: false,
			infoData: [],
			currentNotificationCount: 0,
			load: false,
		};
	}


	render() {
		return (
			<section className='banner'>
				<div className='container animate-fade'>
					<div className='banner-content'>
						<h1>We value your time and content</h1>
						<p>
							Creating social content and getting followers takes time, making
							it profitable for you shouldn't
						</p>
						<ScrollToButton />
						<EnrollingComponent />
					</div>
					<div className='banner-img'>
					<HomePageSvg/>
					</div>
				</div>
			</section>
		);
	}
}

export default Banner;
